export const DEFAULT_IMAGE_CONTAINER = { width: 1000, height: 900 };

export const DataHooks = {
  CARD: 'service-card',
  IMAGE: 'service-image',
  INFO: 'service-info',
};
